export type UpdateOperatorStatusErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class UpdateOperatorStatusError extends Error {
    code: UpdateOperatorStatusErrorCode;

    constructor(code: UpdateOperatorStatusErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
